import React, { useState, useEffect, useContext, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import TabsDS from './TabsDS'
import DetailPageHandler from "./DetailPageHandler"
import { detailsCategories, categorieTabs } from "./Categories/categories"
import { isEditStateContext, isSaveContext, isDeleteContext } from '../store/editableContext'
import { LocalPersistence } from '../factories/index'
import DetailPageSideBar from "./DetailPageSideBar"
import {rightContentWidthContext, UPDATE_RIGHT_CONTENT_WIDTH} from '../layouts/RightContentWidthContext';
import CSIComponents from './CSIComponents';
declare global {
    interface Window {
        editFunction: () => void
        cancelEdition: () => void
        saveEdit: () => void
        breadcrumbInfo: string,
        forceRender: () => void
    }
}

const categorieIndex = [2, 3, 4, 5, 6, 7, 8, 10, 11, 15, 18, 19, 9, 13, 23, 25, 14, 12, 26, 21, 22, 27];

export default function DetailPage() {
    const [categorie, setCategorie] = useState(1)
    const [tabCategorie, setTabCategorie] = useState({ id: 1, name: '' })
    const [isOnEdit, setIsOnEdit] = useState<boolean>(false)
    const [isOnSaving, setIsOnSaving] = useState<boolean>(false)
    const [isOnDelete, setIsOnDelete] = useState<boolean>(false)
    const [ready, setReady] = useState(true); 

    const rightContent:any = useContext(rightContentWidthContext);

    const getCategorieTabs = () => {
        const filteredCategorie: any = detailsCategories.propertyCategories.categories.filter(cat => cat.id === categorie)
        // storing globally the route info
        window.breadcrumbInfo = filteredCategorie[0].name || ""
        return categorieTabs[categorie].tabs
    }

    const isEditable = () => {
        return setIsOnEdit(true)
    }

    const cancelEditable = () => {
        setIsOnSaving(false)
        return setIsOnEdit(false)
    }

    const saveEdit = async () => {
        setIsOnSaving(true)
        // getting data from session persisting
        const localData = new LocalPersistence('session')
        await localData.getSessionPersistence()
        await setIsOnEdit(false)
        return setIsOnSaving(false)
    }

    const deleteData = async () => {
        setIsOnDelete(true)
        // getting data from session persisting
        recoverData()
    }

    const recoverData = async () => {
        const localData = new LocalPersistence('session')
        await localData.getSessionPersistence()
        await setIsOnEdit(false)
        setIsOnDelete(false)
        return setIsOnSaving(false)
    }
    
    const forceRender = useCallback(() => {
        setReady(false);
        return setTimeout(() => setReady(true), 100)
    },[])

    useEffect(() => {
        // setting up initial mount
        setTabCategorie({ id: 1, name: 'General' })
        // making the functionality available in global scope
        window.editFunction = () => isEditable()
        window.cancelEdition = () => cancelEditable()
        window.saveEdit = () => saveEdit()
        window.forceRender = () => forceRender()
    }, [forceRender])

    useEffect(() => {
        const filteredCategorie: any = detailsCategories.propertyCategories.categories.filter(cat => cat.id === categorie)
        // storing globally the route info
        window.breadcrumbInfo = filteredCategorie[0].name || ""
        // set up the tab to be show
        if (categorieTabs[categorie])
            return setTabCategorie(categorieTabs[categorie].tabs[0])
    },[categorie])
    
    const [domWidth, setDomWidth] = useState(238 + 'px')
    
    const iframeDom = document.querySelector('#csi-iframe') as any;
    window.rightContentWidth = '288px'
    if (iframeDom) {
        iframeDom.contentWindow.window.document.body.onresize = function () {
            let dom = document.getElementsByClassName('categorieMenu')[0] as HTMLElement;
            let initwith = 238
            if (dom) {
                initwith = dom.offsetWidth
            }
            setDomWidth(initwith + 'px');
            window.rightContentWidth = initwith + 50 + 'px';
            rightContent?.dispatch({
                type: UPDATE_RIGHT_CONTENT_WIDTH,
                width: initwith + 50 + 'px'
            });
        }
    }
    

    return (
        <section id='DetailsPage'>
            <Grid container spacing={0} className='noWrap'>
                <DetailPageSideBar
                    dataList={Object.values(detailsCategories)}
                    onClick={(e: number) => { setCategorie(e); forceRender() }}
                    currentCategorie={categorie}
                    isOnEdit={isOnEdit}
                />
                { ready ?
                    <>
                    {   
                        categorieIndex.includes(categorie) ? 
                            <CSIComponents
                            categorie={categorie}
                            isEditable={isEditable}
                            cancelEditable={cancelEditable} /> 
                        : 
                        <Grid
                            container
                            spacing={0}
                            style={{ position: 'relative', width: `calc( 100% - ${domWidth})` }}
                            direction="column"
                            justify="flex-start"
                            alignItems="flex-start">
                        <Paper square className='noShadow'>
                            <Grid item xs={12} className="d-flex flex-row justify-content-between align-items-center py-0">
                                <TabsDS
                                    tabs={getCategorieTabs()}
                                    selectedTab={tabCategorie}
                                    onClick={setTabCategorie}
                                />
                            </Grid>
                        </Paper>
                        <div className="container-fluid" data-test="container-fluid">
                            <isEditStateContext.Provider value={isOnEdit}>
                                <isSaveContext.Provider value={isOnSaving}>
                                    <isDeleteContext.Provider value={isOnDelete}>
                                        <DetailPageHandler
                                            type={tabCategorie.name}
                                            isEditable={isEditable}
                                            cancelEditable={cancelEditable}
                                            saveEdit={saveEdit}
                                            deleteData={deleteData}
                                            isOnEdit={isOnEdit}
                                        />
                                    </isDeleteContext.Provider>
                                </isSaveContext.Provider>
                            </isEditStateContext.Provider>
                        </div>
                        </Grid>
                    }
                    </>
                    : <></>
                }
            </Grid>

        </section>
    );
}
